import * as Yup from 'yup';
import messages from './yourProfileForm.messages';
import { REGISTRATION_FIELDS } from '../../../../modules/auth/auth.constants';

export const FIELDS = {
  firstName: 'firstName',
  lastName: 'lastName',
  email: 'email',
  phoneNumber: 'phone',
  agreement: REGISTRATION_FIELDS.agreements1,
};

export const EDITABLE_FIELDS = Object.values(FIELDS);

const phoneRegExp = /^[+]?[0-9]{2}\s?[0-9]{5,13}$/;

export const ValidationSchema = Yup.object().shape({
  [FIELDS.firstName]: Yup.string().required(messages.fieldRequired),
  [FIELDS.lastName]: Yup.string().required(messages.fieldRequired),
  [FIELDS.email]: Yup.string()
    .email(messages.incorrectEmailFormat)
    .required(messages.fieldRequired),
  [FIELDS.phoneNumber]: Yup.string().matches(phoneRegExp, messages.incorrectPhoneNumberFormat),
  [FIELDS.agreement]: Yup.boolean().nullable(false),
});

export const defaultValues = {
  [FIELDS.firstName]: '',
  [FIELDS.lastName]: '',
  [FIELDS.email]: '',
  [FIELDS.phoneNumber]: '',
  [FIELDS.agreement]: false,
};
